import type { IconSvgObject } from './types';

const ConciergeBellIcon: IconSvgObject = [
  ["path", { d: "M3 20.502H21C21.5523 20.502 22 20.0542 22 19.502V18.502C22 17.9497 21.5523 17.502 21 17.502H3C2.44772 17.502 2 17.9497 2 18.502V19.502C2 20.0542 2.44772 20.502 3 20.502Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 14.502C20 10.0837 16.4183 6.50195 12 6.50195C7.58172 6.50195 4 10.0837 4 14.502", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 3.50195V6.50195", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M10 3.50195L14 3.50158", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ConciergeBellIcon;
